import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { ViewUtils } from "@lib/titan2/dist/util/view/ViewUtils";
import { SlingoEvent } from "../../../controller/event/SlingoEvent";
import { AbstractGameView } from "./AbstractGameView";
/**
 * TotalWinCounter.ts
 */
export class TotalWinCounter extends AbstractGameView {
    createProperties(landscapeProperties, portraitProperties) {
        super.createProperties(landscapeProperties, portraitProperties);
        this.landscapeProperties = landscapeProperties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.uiProperties;
    }
    create() {
        super.create();
        this.background = TitanSprite.createSprite(this, "background", this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties);
        this.titleField = ViewUtils.createField(this, this.landscapeProperties.titleFieldProperties, this.portraitProperties?.titleFieldProperties);
        this.valueField = ViewUtils.createField(this, this.landscapeProperties.valueFieldProperties, this.portraitProperties?.valueFieldProperties);
    }
    postCreate() {
        super.postCreate();
        Logger.addObjectRef(this, "TotalWinCounter");
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(SlingoEvent.GAME_SUMMARY_COMPLETE, this.handleGameSummaryComplete);
        this.registerGame(SlingoEvent.SCATTER_WIN_COUNT_END, this.handleScatterWinCountEnd);
        this.registerGame(CommonGameEvent.RECOVERY, this.handleScatterWinCountEnd);
        this.registerGame(CommonGameEvent.PURCHASE_ENTRY, this.reset);
    }
    handleGameSummaryComplete() {
        const totalWin = this.model.getTotalWin();
        this.updateValue(totalWin > 0 ? this.formatCurrency(totalWin) : "");
    }
    handleScatterWinCountEnd() {
        const totalWin = this.model.getTotalWin();
        this.updateValue(totalWin > 0 ? this.formatCurrency(totalWin) : "");
    }
    reset() {
        this.updateValue("");
    }
    updateValue(text) {
        if (text === "") {
            this.titleField.visible = true;
            this.valueField.visible = false;
        }
        else {
            this.titleField.visible = false;
            this.valueField.visible = true;
        }
        this.valueField.setText(text);
    }
}
//# sourceMappingURL=TotalWinCounter.js.map